<template>
  <div class="governance-page">
    <GovernanceComponent />
  </div>
</template>

<script>
import GovernanceComponent from '@/components/governance/GovernanceView.vue'

export default {
  name: 'GovernanceView',
  components: {
    GovernanceComponent
  }
}
</script>

<style scoped>
.governance-page {
  width: 100%;
  height: 100%;
}
</style>
